// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__35hv9","inputDescription":"styles_inputDescription__3YQoT"};